import {FaFacebookF} from 'react-icons/fa'
import {BsInstagram, BsTwitter} from 'react-icons/bs'

const Footer = () => {
  return (
    <footer className='bg-primary py-12 text-center text-[0.9rem] mt-28'>
      <a href='#home' className='footer-logo text-2xl font-medium mb-8 inline-block !text-bg'>TOSE TONY</a>

      <ul className='flex flex-wrap justify-center gap-8 mx-auto mb-12 max-[600px]:flex-col max-[600px]:gap-6'>
        <li><a href='#home' className='!text-bg'>Home</a></li>
        <li><a href='#about' className='!text-bg'>About</a></li>
        <li><a href='#experience' className='!text-bg'>Experience</a></li>
        <li><a href='#services' className='!text-bg'>Services</a></li>
        <li><a href='#contact' className='!text-bg'>Contact</a></li>
      </ul>

      <div className='flex gap-4 justify-center mb-16 max-[600px]:mb-[2.6rem]'>
      <a href='https://facebook.com' target='_blank' rel='noreferrer' className='bg-bg text-white p-3 rounded-lg flex border border-transparent hover:bg-transparent hover:!text-bg hover:border-bg'><FaFacebookF/></a>
      <a href='https://instagram.com' target='_blank' rel='noreferrer' className='bg-bg text-white p-3 rounded-lg flex border border-transparent hover:bg-transparent hover:!text-bg hover:border-bg'><BsInstagram/></a>
      <a href='https://twitter.com' target='_blank' rel='noreferrer' className='bg-bg text-white p-3 rounded-lg flex border border-transparent hover:bg-transparent hover:!text-bg hover:border-bg'><BsTwitter/></a>
      </div>

      <div className='mb-16 text-bg overflow-hidden whitespace-nowrap'>
        <small className='inline-block animate-marquee'>&copy; Tose Tony. All right reserved</small>
      </div>
    </footer>
  )
}

export default Footer
